/**
 * Query serialization for Spring MVC list parameters: repeated keys
 * (`statuses=A&statuses=B`), not bracket notation. Matches axios default for arrays.
 *
 * Use as `paramsSerializer` on axios GET requests that send `List`-bound query params.
 */
export function serializeParamsForSpringBoot(params: Record<string, unknown>): string {
  const parts: string[] = [];
  for (const key in params) {
    if (Object.prototype.hasOwnProperty.call(params, key)) {
      const value = params[key];
      if (Array.isArray(value)) {
        value.forEach((item) => {
          parts.push(`${encodeURIComponent(key)}=${encodeURIComponent(String(item))}`);
        });
      } else if (value !== null && value !== undefined) {
        parts.push(`${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`);
      }
    }
  }
  return parts.join('&');
}
